import { render } from "./PortalSettingsGeneral.vue?vue&type=template&id=ad4b57a8"
import script from "./PortalSettingsGeneral.vue?vue&type=script&lang=js"
export * from "./PortalSettingsGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__